import { Img, Text } from "@coaching-culture/ui";
import styled from "styled-components";
import meditationSrc from "../../img/meditation.svg";
import logoSrc from "../../img/logo.png";

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 32px;
`;

export const HoldingPage = () => {
  return (
    <Container>
      <Img
        src={logoSrc}
        width={100}
        style={{ position: "absolute", top: 20, left: 20 }}
      />
      <Img src={meditationSrc} mb={3} />
      <Text as="h1" fontSize="display" fontWeight={600} color="black" mb={1}>
        Take a moment to reflect...
      </Text>
      <Text color="textMuted" textAlign="center">
        We're making some changes so the platform is currently unavailable.
        Check back soon
      </Text>
    </Container>
  );
};
